import { useDispatch } from 'react-redux';
import { Col, Alert, Spinner, Badge } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getGuideList } from '../../../../slices/thunks';
import { Link } from 'react-router-dom';
import { ODataGrid } from '../../../../Components/OElements/ODataGrid';
import { setRequireCloseModal, setRequireReloadSelectionItemsGrid } from '../../../../slices/guide/reducer';
import ConfirmStatementModal from './Modals/ConfirmStatementModal';
import GuideDetail from '../../Guides/GuideDetail';
import { toast } from 'react-toastify';

const StatementGuide = () => {
	const dispatch = useDispatch();
	const history = useNavigate();

	const selectorGuides = createSelector(
		state => state.Guides,
		guide => ({
			guideList: guide.guideList,
			isLoadingList: guide.isLoadingList,
			isGuideSuccess: guide.isGuideSuccess,
			error: guide.error,
			isAdding: guide.isAdding,
			isAdded: guide.isAdded,
			isAddError: guide.isAddError,
			isUpdating: guide.isUpdating,
			isUpdated: guide.isUpdated,
			isUpdateError: guide.isUpdateError,
			isDeleting: guide.isDeleting,
			isDeleted: guide.isDeleted,
			isDeleteError: guide.isDeleteError,
			requireCloseModal: guide.requireCloseModal,
			requireReloadSelectionItemsGrid: guide.requireReloadSelectionItemsGrid
		})
	);

	const {
		guideList,
		isLoadingList,
		requireCloseModal,
		requireReloadSelectionItemsGrid
	} = useSelector(selectorGuides);

	useEffect(() => {
		dispatch(getGuideList({
			status_guide_id: '65f4301f2b6a531c6b6b3f33',
			status_final_destination_management_id: '663359e1b12192d64dd219c0'
		}));
	}, []);

	const [dataGuide, setDataGuide] = useState({});
	const [isEdit, setIsEdit] = useState(false);

	// Delete Guide
	const [modal, setModal] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);
	//Tab
	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	function handleToggleModal() {
		setModal(!modal);
		toggleTab('1');
		// validation.resetForm();
	}

	function handleToggleModalDelete() {
		setModalDelete(!modalDelete);
	}

	// Delete Data
	const handleClickDelete = guide => {
		setDataGuide(guide);
		setModalDelete(true);
	};

	// Update Data
	const handleClickEdit = guide => {
		setDataGuide(guide);
		handleToggleModal();
	};

	const [guideSelectedList, setGuideSelectedList] = useState([])

	const [selectionStatementList, setSelectionStatementList] = useState([]);
	const [selectionToStatementdList, setSelectionToStatementdList] = useState([]);

	function handleRemoveGuideSelectionList(guide) {
		let selectionStatementListToUpdate = selectionStatementList;
		delete selectionStatementListToUpdate[guide._id];
		setSelectionStatementList(selectionStatementListToUpdate);
		setGuideSelectedList(guideSelectedList.filter(item => item._id != guide._id));
	}

	const [modalGuideDetail, setModalGuideDetail] = useState(false);
	const [selectedGuideId, setSelectedGuideId] = useState(null);
	const toggleModal = () => setModalGuideDetail(!modalGuideDetail);
	const handleGuideClick = (guide) => {
		setSelectedGuideId(guide);
		toggleModal();
	};


	const columnsTableStatement = useMemo(
		() => [
			{
				header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
				accessorKey: 'guide',
				columnDefType: 'display',
				size: 'auto',
				Cell: cellProps => {
					return (
						<React.Fragment>
							<div className='d-flex'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												to='/warehouse/guides'
											>
												<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												to='#'
												className='remove-item-btn'
												onClick={() => {
													const guideData = cellProps.row.original;
													handleClickDelete(guideData);
												}}
											>
												<i className='ri-delete-bin-fill align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
		{
			header: "Guía",
			accessorKey: "guide_number",

			size: "auto",
			Cell: ({ row }) => {
				const displayNumber = row.original.folio || row.original.guide_number || '-';
				return (
					<span 
						onClick={() => handleGuideClick(row.original)} 
						style={{ cursor: "pointer", color: "var(--vz-primary)", textDecoration: "none", fontWeight: "bold" }}
					>
						{displayNumber}
					</span>
				);
			},
		},
			{ header: 'Fecha', accessorKey: 'guide_date', dataType: 'date' },
			{
				header: 'Estado',
				accessorKey: 'status_guide',
				size: 'auto',
				Cell: ({ row }) => {
					let status = row.original.status_guide
					let bgColor = status.bgcolor;
					let txColor = status.txcolor;
					return (
						<div>
							<span className={`badge`} style={{ backgroundColor: bgColor, color: txColor }}>
								{row.original.status_guide?.name
									? row.original.status_guide.name
									: ''}
							</span>
						</div>
					);
				},
			},

			{ header: "Origen", accessorKey: "establishment.name", size: "auto" },
			{
				header: "Destino", accessorKey: "destination", size: "auto",
				Cell: ({ row }) => (
					row.original.final_destination?.name || row.original.warehouse?.name || ""
				),
			},
			{ header: 'Kg Enviados', accessorKey: 'kilograms_sended', size: 'auto' },
			{ header: 'Kg Recibidos', accessorKey: 'kilograms_received', size: 'auto' },
			{ header: 'Kg Certificados', accessorKey: 'kilograms_certified', size: 'auto' },
			{ header: 'Factura', accessorKey: 'invoce', size: 'auto', visible: false },
			{ header: 'IVA', accessorKey: 'iva', size: 'auto', visible: false },
			{ header: 'Subtotal', accessorKey: 'subtotal', size: 'auto', visible: false },
			{ header: 'Total', accessorKey: 'total', size: 'auto', visible: false },
			{
				header: 'Observación',
				accessorKey: 'observation',
				size: 'auto', visible: false,
			},
		],
		[handleClickEdit]
	);

	const columnsTableToStatement = useMemo(
		() => [
			{
				header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
				accessorKey: 'guide',
				columnDefType: 'display',
				size: 'auto',
				Cell: cellProps => {
					return (
						<React.Fragment>
							<div className='d-flex'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												to='#'
												className='remove-item-btn'
												onClick={() => {
													const guideData = cellProps.row.original;
													handleRemoveGuideSelectionList(guideData);
												}}
												title='Deseleccionar Residuo'
											>
												<i className='ri-indeterminate-circle-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
		{
			header: "Guía",
			accessorKey: "guide_number",

			size: "auto",
			Cell: ({ row }) => {
				const displayNumber = row.original.folio || row.original.guide_number || '-';
				return (
					<span 
						onClick={() => handleGuideClick(row.original)} 
						style={{ cursor: "pointer", color: "var(--vz-primary)", textDecoration: "none", fontWeight: "bold" }}
					>
						{displayNumber}
					</span>
				);
			},
		},
			{ header: 'Fecha', accessorKey: 'guide_date', dataType: 'date' },
			{
				header: 'Estado',
				accessorKey: 'status_guide',
				size: 'auto',
				Cell: ({ row }) => {
					let status = row.original.status_guide
					let bgColor = status.bgcolor;
					let txColor = status.txcolor;
					return (
						<div>
							<span className={`badge`} style={{ backgroundColor: bgColor, color: txColor }}>
								{row.original.status_guide?.name
									? row.original.status_guide.name
									: ''}
							</span>
						</div>
					);
				},
			},
			{
				header: 'Establecimiento origen',
				accessorKey: 'establishment.name',
				size: 'auto',
			},
			{
				header: 'Bodega transitoria',
				accessorKey: 'warehouse.name',
				size: 'auto',
			},
			{
				header: 'Destino Final',
				accessorKey: 'final_destination.name',
				size: 'auto',
			},
			{ header: 'Kg Recibidos', accessorKey: 'kilograms_received', size: 'auto' },
			{ header: 'Kg Enviados', accessorKey: 'kilograms_sended', size: 'auto' },
			{ header: 'Kg Certificados', accessorKey: 'kilograms_certified', size: 'auto' },
			{ header: 'Factura', accessorKey: 'invoce', size: 'auto' },
			{ header: 'IVA', accessorKey: 'iva', size: 'auto' },
			{ header: 'Subtotal', accessorKey: 'subtotal', size: 'auto' },
			{ header: 'Total', accessorKey: 'total', size: 'auto' },
			{
				header: 'Observación',
				accessorKey: 'observation',
				size: 'auto',
			},
		],
		[handleClickEdit]
	);


	const [goToSelectionItemsTable, setGoToSelectioItemsTable] = useState(false);

	const handlerGoToSelectionList = () => {
		setGoToSelectioItemsTable(!goToSelectionItemsTable);
	}

	const [isOpenConfirmReceptionModal, setIsOpenConfirmReceptionModal] = useState(false);
	const [establishment, setEstablishment] = useState(null);
	const [kilograms_declared, setTotalKg] = useState(0);

	function checkEstablishment() {
		const uniqueEstablishments = guideSelectedList
			.filter(item => item.establishment_id != null)
			.reduce((acc, item) => {
				if (!acc.some(el => el.establishment_id === item.establishment_id)) {
					acc.push(item);
				}
				return acc;
			}, []);

		const totalKilogramsCertified = guideSelectedList
			.filter(item => item.kilograms_certified != null)
			.reduce((total, item) => total + item.kilograms_certified, 0);

		return {
			isSingle: uniqueEstablishments.length === 1,
			establishment: uniqueEstablishments.length === 1 ? uniqueEstablishments[0].establishment : null,
			kilograms_declared: totalKilogramsCertified
		};
	}

	function handlerToggleConfirmReceptionModal() {
		const { isSingle: isOkEstablishment, establishment, kilograms_declared } = checkEstablishment();
		if (isOkEstablishment) {
			setEstablishment(establishment)
			setTotalKg(kilograms_declared)
			setIsOpenConfirmReceptionModal(!isOpenConfirmReceptionModal);
		} else {
			if (!isOkEstablishment) {
				toast.error(
					'Tiene seleccionada guías de más de un establecimiento. Las declaraciones debe ser por establecimiento.',
					{ autoClose: 4000 }
				);
			}
		}
	}

	// Effect to manage toggle modal by reducer state require
	useEffect(() => {
		if (isOpenConfirmReceptionModal) {
			if (requireCloseModal) {
				dispatch(setRequireCloseModal(false));
				handlerToggleConfirmReceptionModal();
			}
		}
	}, [requireCloseModal]);

	// Effect to manage reload grid by reducer state require
	useEffect(() => {
		if (requireReloadSelectionItemsGrid) {
			dispatch(setRequireReloadSelectionItemsGrid(false))
			dispatch(getGuideList({
				status_guide_id: '65f4301f2b6a531c6b6b3f33',
				status_final_destination_management_id: '663359e1b12192d64dd219c0'
			}));
			setSelectionStatementList({});
			setGuideSelectedList([]);
		}
	}, [requireReloadSelectionItemsGrid]);

	useEffect(() => {
		if (selectionStatementList) {
			let selectionItems = [];
			Object.entries(selectionStatementList).forEach(([key, value]) => {
				if (key != null) {
					selectionItems.push(guideList.find(item => item._id == key));
				}
			})
			setGuideSelectedList(selectionItems);
		}

	}, [selectionStatementList])

	return (
		<React.Fragment>
			<div className='row'>
				<Col lg={12}>
					<div className='card'>
						<div className='card-header border-0'>
							<div className='d-flex align-items-center'>
								{/* <h5 className='card-title mb-0 flex-grow-1 text-capitalize'>
									{(goToSelectionItemsTable ? 'Lista de guias seleccionadas' : 'Lista de guías por seleccionar')}
								</h5> */}
								{/* <div className='flex-shrink-0'>
									<div className='d-flex flex-wrap gap-2'>
										<button
											className='btn btn-label btn-primary'
											onClick={handlerGoToSelectionList}
											disabled={(guideSelectedList.length || goToSelectionItemsTable && guideSelectedList.length == 0 ? false : true )}
										>
											<i className={`ri-arrow-${(!goToSelectionItemsTable ? 'right' : 'left')}-line label-icon`}></i>{' '}
											{(!goToSelectionItemsTable ? 'Ir a residuos seleccionados' : 'Volver a residuos por recepcionar')}
											{!goToSelectionItemsTable ? 
												<Badge color="white" pill className='mx-1'>
													<div className='text-danger fw-bold p-0 m-0'>{guideSelectedList.length}</div>
												</Badge>
											:
												null
											}
										</button>
									</div>
								</div> */}
							</div>
						</div>

						<div className={`p-3 ${(goToSelectionItemsTable ? 'd-none' : '')}`}>
							<ODataGrid
								columns={columnsTableStatement}
								data={guideList || []}
								getRowIdTable={(originalRow) => originalRow._id}
								selectAllMode={'all'}
								selection={{
									rowSelection: selectionStatementList,
									setRowSelection: setSelectionStatementList,
								}}
								isLoadingData={isLoadingList}
							/>
							<div className='w-100 d-flex flex-row-reverse gap-2 my-4'>
								<button
									className='btn btn-label btn-primary'
									onClick={() => handlerToggleConfirmReceptionModal()}
									disabled={(guideSelectedList.length ? false : true)}
								>
									<i className={`${Icons.check} label-icon`}></i>{' '}
									Declarar Residuos
								</button>
							</div>
						</div>
						{/* <div className={`p-3 ${(!goToSelectionItemsTable ? 'd-none': '')}`}>
							<ODataGrid
								columns={columnsTableToStatement}
								data={guideSelectedList || []}
								getRowIdTable={(originalRow) => originalRow._id}
							/>
							<div className='w-100 d-flex flex-row-reverse gap-2 my-4'>
								<button
									className='btn btn-label btn-primary'
									onClick={() => handlerToggleConfirmReceptionModal()}
									disabled={(guideSelectedList.length ? false : true )}
								>
									<i className='icon-check'></i>{' '}
									Declarar residuos
								</button>
							</div>
						</div> */}
					</div>
				</Col>
			</div>
			<ConfirmStatementModal
				guides={guideSelectedList}
				isOpen={isOpenConfirmReceptionModal}
				handlerToggleModal={handlerToggleConfirmReceptionModal}
				establishment={establishment}
				kilograms_declared={kilograms_declared}
			/>


			{selectedGuideId && (
				<GuideDetail
					info={selectedGuideId}
					isOpen={modalGuideDetail}
					toggle={toggleModal}
				/>
			)}

		</React.Fragment>
	);
};

export default StatementGuide;